import { CategoryDto, CreateCategoryRequest, UpdateCategoryRequest } from '../dto/categories';
import { httpArg, httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

/**
 * Service for managing news categories.
 * Both default and user-defined categories.
 */
@httpRoute('/api/category')
export abstract class ICategoryService {
	/**
	 * Get all categories for a user (both default and user-defined)
	 */
	@httpGet('get-categories')
	getCategories(@httpUserId() userId?: string): Promise<CategoryDto[]> {
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Create a new user-defined category
	 */
	@httpPost('create-category')
	createCategory(
		@httpArg('request') request: CreateCategoryRequest,
		@httpUserId() userId?: string
	): Promise<CategoryDto> {
		void userId;
		void request;
		throw new Error('Not implemented');
	}

	/**
	 * Update an existing user-defined category
	 */
	@httpPost('update-category')
	updateCategory(
		@httpArg('request') request: UpdateCategoryRequest,
		@httpUserId() userId?: string
	): Promise<CategoryDto> {
		void userId;
		void request;
		throw new Error('Not implemented');
	}

	/**
	 * Delete a user-defined category
	 */
	@httpPost('delete-category')
	deleteCategory(
		@httpArg('categoryId') categoryId: string,
		@httpUserId() userId?: string
	): Promise<void> {
		void userId;
		void categoryId;
		throw new Error('Not implemented');
	}

	/**
	 * Get count of user-defined categories
	 */
	@httpGet('get-user-category-count')
	getUserCategoryCount(@httpUserId() userId?: string): Promise<number> {
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Check if a category is a default system category
	 */
	@httpGet('is-default-category')
	isDefaultCategory(@httpArg('categoryId') categoryId: string): boolean {
		void categoryId;
		throw new Error('Not implemented');
	}
}
